import { dateFormat, magazineDateFormat } from '@utils/safe'
import { useTrans } from '../../../hooks'
import { MenuItemType } from '../../../utils/types'
import { Chip, WContainer, WImage } from '../../atoms'
import styles from './ImageWithChips.module.sass'

interface Props {
  className?: string
  item?: MenuItemType
  chips?: string[]
  date?: string
}

const ImageWithChips = (props: Props) => {
  const { className = '', item = undefined, chips = [], date = undefined } = props

  const t = useTrans()

  return item?.image || chips?.length ? (
    <div className={`${styles.root} ${className}`}>
      {item.image && (
        <WContainer>
          <WImage
            maxHeight={508}
            maxWidth={1240}
            src={item.image}
            alt={item.imageAlt}
            className={styles.image}
            priority
            loading="eager"
          />
        </WContainer>
      )}
      {!!chips?.length && (
        <WContainer variant="sm">
          <div className={styles.container}>
            <div className={styles.chipsContainer}>
              {chips.map((chip) => (
                <Chip key={chip} label={chip} />
              ))}
            </div>
            {date && <p className={styles.date}>{magazineDateFormat(date)}</p>}
          </div>
        </WContainer>
      )}
    </div>
  ) : (
    <></>
  )
}

export default ImageWithChips
